import React, { useContext } from "react";
import "./FooterTwo.css";
import "./ResponsiveFooterTwo.css";
import { filterKey } from "../../helper/function";
import { dataContext } from "../../context/DataContextProviderr";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "footer-homePage"
  );
  return (
    <div className="footer-two">
      <div className="content-container">
        <div className="left">
          <div className="bottom">
            <div className="address">
              <div className="call num">
                <div className="img">
                  <img src="/pic/call.png" alt="phone-icon" />
                </div>
                <div className="group-1">
                  <p>
                    {filterKey(filterAllWebParts, "tell-1")?.map(
                      (item) => item.Value
                    )}
                  </p>
                  <p>
                    {filterKey(filterAllWebParts, "tell-3")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
                <div className="group-2">
                  <p>
                    {filterKey(filterAllWebParts, "tell-2")?.map(
                      (item) => item.Value
                    )}
                  </p>
                  <p>
                    {filterKey(filterAllWebParts, "tell-4")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
              </div>
              <div className="location">
                <div className="img">
                  <img src="/pic/location.png" alt="location-icon" />
                </div>
                <div className="group-1">
                  <p>
                    {filterKey(filterAllWebParts && filterAllWebParts, "address")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className="shop">
              <p>سامانه خرید آرد</p>
              <a
                href={filterKey(filterAllWebParts, "purchase-flour-link")?.map(
                  (item) => item.Value
                )}
                target="_blank"
                rel="noreferrer"
              >
                Gfloursale.Banksepah.Ir
              </a>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="factory-img">
            <img
              src="/pic/factory.png"
              alt="factory-icon"
              className="factory"
            />
            <img src="/pic/footerBg1.png" alt="walpaper" className="walpaper" />
          </div>
          <div className="content-footer">
            <p className="p1">
              نظرات و پیشنهادات خود را <Link to="/contactUs"><span className="p2">با ما</span></Link> به
              اشتراک بگذارید
            </p>
          </div>
        </div>
      </div>
      <div className="copy-right border-top">
        <p>
          {filterKey(filterAllWebParts, "footer-copyright")?.map(
            (item) => item.Value
          )}
        </p>
      </div>
    </div>
  );
};

export default FooterTwo;
